import { lastValueFrom, Observable } from 'rxjs';

export function toPromise<ObservableType>(
  observable: Observable<ObservableType>
) {
  return lastValueFrom(observable, {
    defaultValue: true,
  }) as Promise<ObservableType>;
}
